var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppFeatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7094 32.6093L15.6262 24.5045L9.37575 19.1291L17.6056 18.3582L20.835 10.8367L24.0644 18.4415L32.2943 19.1291L26.0437 24.5045L27.9606 32.6093L20.835 28.3173L13.7094 32.6093ZM20.835 0.835938C23.5711 0.835938 26.2804 1.37485 28.8082 2.42191C31.336 3.46896 33.6329 5.00366 35.5676 6.93837C37.5023 8.87308 39.037 11.1699 40.084 13.6977C41.1311 16.2255 41.67 18.9348 41.67 21.6709C41.67 27.1967 39.4749 32.4962 35.5676 36.4035C31.6602 40.3108 26.3608 42.5059 20.835 42.5059C18.0989 42.5059 15.3896 41.967 12.8618 40.92C10.334 39.8729 8.03714 38.3382 6.10243 36.4035C2.19511 32.4962 0 27.1967 0 21.6709C0 16.1452 2.19511 10.8457 6.10243 6.93837C10.0098 3.03105 15.3092 0.835938 20.835 0.835938ZM20.835 5.00294C16.4144 5.00294 12.1748 6.75903 9.04894 9.88488C5.92309 13.0107 4.167 17.2503 4.167 21.6709C4.167 26.0916 5.92309 30.3311 9.04894 33.457C12.1748 36.5828 16.4144 38.3389 20.835 38.3389C25.2556 38.3389 29.4952 36.5828 32.6211 33.457C35.7469 30.3311 37.503 26.0916 37.503 21.6709C37.503 17.2503 35.7469 13.0107 32.6211 9.88488C29.4952 6.75903 25.2556 5.00294 20.835 5.00294Z",
    fill: "#4EB9FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppFeatureIcon);
export default __webpack_public_path__ + "static/media/appFeatureIcon.415dd331a51e47fad2617e00c5f1a00c.svg";
export { ForwardRef as ReactComponent };